const LOG_LEVELS = {
    debug: 0,
    info: 1,
    warn: 2,
    error: 3,
};
function shouldLog(configLevel, messageLevel) {
    return LOG_LEVELS[messageLevel] >= LOG_LEVELS[configLevel];
}
function formatTimestamp() {
    return new Date().toISOString();
}
function isDevelopment() {
    return (typeof process !== "undefined" && process.env?.NODE_ENV === "development");
}
export function createLogger(config = {}) {
    const fullConfig = {
        minLevel: isDevelopment() ? "debug" : "warn",
        enableConsole: true,
        prefix: "[Membentry]",
        ...config,
    };
    return new Logger(fullConfig);
}
export class Logger {
    constructor(config) {
        this.config = config;
    }
    log(level, message, context) {
        if (!shouldLog(this.config.minLevel, level)) {
            return;
        }
        const entry = {
            level,
            message,
            timestamp: formatTimestamp(),
            context,
        };
        if (this.config.enableConsole) {
            const prefix = this.config.prefix ? `${this.config.prefix} ` : "";
            const formattedMessage = `${prefix}[${entry.timestamp}] [${level.toUpperCase()}] ${message}`;
            switch (level) {
                case "debug":
                    console.debug(formattedMessage, context ?? "");
                    break;
                case "info":
                    console.info(formattedMessage, context ?? "");
                    break;
                case "warn":
                    console.warn(formattedMessage, context ?? "");
                    break;
                case "error":
                    console.error(formattedMessage, context ?? "");
                    break;
            }
        }
    }
    debug(message, context) {
        this.log("debug", message, context);
    }
    info(message, context) {
        this.log("info", message, context);
    }
    warn(message, context) {
        this.log("warn", message, context);
    }
    error(message, context) {
        this.log("error", message, context);
    }
}
export const logger = createLogger();
